class SnapGoogleAnalytics {
  name = "Google Analytics";

  constructor({ creds, trackerName }) {
    this.creds = creds;
    this.trackerName = trackerName;

    if (ga) {
      ga(`require`, "ecommerce");
      ga(`${this.trackerName}.require`, "ecommerce");
    } else {
      this.generateScripts(creds);
    }
  }

  generateScripts(creds) {
    //generate scripts to load google analytics at some later date
  }

  callMethod = (methodName, payload) => {
    if (window.location.host !== "stg1.amploadvance.com") {
      ga(methodName, payload);
    }

    if (this.trackerName) {
      ga(`${this.trackerName}.${methodName}`, payload);
    }
  };

  addTransaction(payload = {}) {
    const { id, revenue } = payload;

    this.callMethod("ecommerce:addTransaction", {
      id: id,
      revenue: revenue,
    });
  }

  addItem(payload = {}) {
    const { id, name, price } = payload;

    this.callMethod(`ecommerce:addItem`, {
      id: id,
      name: name,
      price: price,
      quantity: 1,
    });
  }

  track(payload = {}) {
    const { hitType, eventCategory, eventLabel, eventAction } = payload;

    this.callMethod("send", {
      hitType,
      eventCategory,
      eventLabel,
      eventAction,
    });
  }

  send() {
    this.callMethod(`ecommerce:send`);
  }

  clear() {
    this.callMethod(`ecommerce:clear`);
  }
}

export default SnapGoogleAnalytics;
